import { ChevronLeft } from 'lucide-react'
import { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { ActionSection, CustomDropdown, RadioSection } from '@/components/ui/custom-dropdown'
import { HEADER_HEIGHT, TOOLBAR_HEIGHT } from '@/lib/constants'

import { QuickNav } from './quick-nav'

export type ToolbarItem = {
  icon: ReactNode
  label: string
  onClick: () => void
  show?: boolean
}

type HeaderProps = {
  title: string | React.ReactNode
  onClose: () => void
  dropdownSections?: (RadioSection | ActionSection)[]
  /** 常設シートのように z-index の高い要素がある画面でメニューを手前に出す用 */
  dropdownContentClassName?: string
  /** メニューの左に並べる操作。1 つだけの切り替えなど、行を増やしたくないとき用 */
  actions?: ReactNode
  toolbarItems?: ToolbarItem[]
  customToolbar?: ReactNode
}

export const Header = ({
  title,
  onClose,
  dropdownSections,
  dropdownContentClassName,
  actions,
  toolbarItems,
  customToolbar,
}: HeaderProps) => {
  const visibleToolbarItems = toolbarItems?.filter((item) => item.show !== false) ?? []
  const hasToolbar = visibleToolbarItems.length > 0 || customToolbar

  return (
    <div className="relative bg-background z-10 border-b border-gray-600">
      <div
        className="flex justify-between items-center px-2"
        style={{
          height: HEADER_HEIGHT,
        }}
      >
        <div className="flex gap-2 items-center flex-1 min-w-0">
          <ChevronLeft size={40} onClick={onClose} className="shrink-0" />
          <QuickNav />
          {typeof title === 'string' ? (
            <div className="text-white whitespace-nowrap overflow-hidden text-ellipsis flex-1 min-w-0">{title}</div>
          ) : (
            <div className="flex-1 min-w-0 flex justify-center">{title}</div>
          )}
        </div>
        <div className="shrink-0 ml-2 flex items-center gap-2">
          {actions}
          {dropdownSections && dropdownSections.length > 0 && (
            <CustomDropdown sections={dropdownSections} contentClassName={dropdownContentClassName} />
          )}
        </div>
      </div>
      {hasToolbar && (
        <div
          className="relative z-10 flex justify-center items-center gap-2 bg-background/80 backdrop-blur-sm border-b border-gray-600"
          style={{
            height: TOOLBAR_HEIGHT,
          }}
        >
          {customToolbar}
          {visibleToolbarItems.map((item) => (
            <Button
              key={item.label}
              variant="ghost"
              size="icon"
              onClick={item.onClick}
              aria-label={item.label}
              title={item.label}
            >
              {item.icon}
            </Button>
          ))}
        </div>
      )}
    </div>
  )
}
